import { useEffect, useState } from "react";
import ReactSelect from "react-select";
import EstadoBadge from "../components/EstadoBadge";
import Loader from "../components/Loader";
import {
  listClientLazy,
  updateClienteReceptor,
  createClienteReceptor,
  changeClienteReceptor,
} from "../api/clientesReceptor";
import { showAlertError } from "../utils/alertHelper";

import {
  listDepartamento012,
  listMunicipio013,
  listActividadEconomica19,
  listTipo_persona029,
  listTipo_documento022,
} from "../api/hacienda";

const Clientes = () => {
  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [actividad, setActividadEconomica] = useState([]);
  const [tipoPersona, setTipoPersona] = useState([]);
  const [tipoDocReceptor, setTipoDocReceptor] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [clienteReceptor, setClienteReceptor] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [currentId, setCurrentId] = useState(null);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [buscar, setBuscar] = useState("");

  const [form, setForm] = useState({
    nombre: "",
    nombreComercial: "",
    nit: "",
    dui: "",
    nrc: "",
    actividad: "",
    departamento: "",
    municipio: "",
    direccionComplemento: "",
    telefono: "",
    correo: "",
    status: "",
    tipoPersona: "",
    id_documento_identificacion_receptor: "",
    numeroDocumento: "",
  });

  const fetchData = async (p = 1) => {
    try {
      const data = await listClientLazy(p, limit, buscar);
      setClienteReceptor(data.data);

      const dep = await listDepartamento012({});
      setDepartamentos(dep.data);

      const mun = await listMunicipio013({});
      setMunicipios(mun.data);

      const act = await listActividadEconomica19({});
      setActividadEconomica(act.data);

      const tp = await listTipo_persona029();
      setTipoPersona(tp.data);

      const tdoc = await listTipo_documento022();
      setTipoDocReceptor(tdoc.data);

      setTotalPages(data.totalPages);
      setPage(data.currentPage);

    } catch (error) {
      console.error("Error al obtener las categorías", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page);
    // eslint-disable-next-line 
  }, [page, limit, buscar]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const openModalForNew = () => {
    setForm({
      nombre: "",
      nombreComercial: "",
      nit: "",
      dui: "",
      nrc: "",
      actividad: "",
      departamento: "",
      municipio: "",
      direccionComplemento: "",
      telefono: "",
      correo: "",
      status: "",
      tipoPersona: "",
      id_documento_identificacion_receptor: "",
      numeroDocumento: "",
    });
    setEditMode(false);
    setCurrentId(null);
    setShowModal(true);
  };

  const openModalForEdit = (c) => {
    setForm({
      nombre: c.nombre || "",
      nombreComercial: c.nombreComercial || "",
      nit: c.nit || "",
      dui: c.dui || "",
      nrc: c.nrc || "",
      actividad: c.id_actividad_economica?.toString() || "",
      departamento: c.id_departamento?.toString() || "",
      municipio: c.id_municipio?.toString() || "",
      direccionComplemento: c.direccionComplemento || "",
      telefono: c.telefono || "",
      correo: c.correo || "",
      status: String(c.status ?? ""),
      tipoPersona: c.id_tipo_persona?.toString() || "",
      id_documento_identificacion_receptor: c.id_documento_identificacion_receptor?.toString() || "",
      numeroDocumento: c.numeroDocumento || "",
    });
    setCurrentId(c.id);
    setEditMode(true);
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.id_documento_identificacion_receptor) {
      showAlertError("Campo Requerido", "Debe seleccionar un Tipo Doc. Identificador.");
      return;
    }
    setSubmitting(true);
    try {
      const data = {
        nombre: form.nombre,
        nombreComercial: form.nombreComercial,
        nrc: form.nrc,
        id_actividad_economica: form.actividad,
        id_departamento: form.departamento,
        id_municipio: form.municipio,
        id_tipo_persona: form.tipoPersona,
        direccionComplemento: form.direccionComplemento,
        telefono: form.telefono,
        correo: form.correo,
        status: form.status,
        id_documento_identificacion_receptor: form.id_documento_identificacion_receptor,
        numeroDocumento: form.numeroDocumento,
      };

      if (editMode) {
        await updateClienteReceptor(currentId, data);
      } else {
        await createClienteReceptor(data);
      }

      await fetchData();
      setShowModal(false);
    } catch (error) {
      console.error("Error al guardar el cliente", error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleToggleStatus = async (c) => {
    const newStatus = c.status === 1 ? 0 : 1;
    try {
      await changeClienteReceptor(c.id, { status: newStatus });
      await fetchData();
    } catch (error) {
      console.error("Error al cambiar el estado del cliente", error);
    }
  };

  const handleSelectChange = (value, name) => {
    setForm((prev) => {
      const newState = { ...prev, [name]: value ? value.value : "" };
      if (name === "departamento") {
        newState.municipio = "";
      }
      return newState;
    });
  };

  const opcionesDepartamento = departamentos.map((d) => ({
    value: d.id.toString(),
    label: `${d.codigo} | ${d.name}`,
  }));

  const opcionesMunicipio = municipios
    .filter((m) => !form.departamento || m.id_departamentoFact?.toString() === form.departamento)
    .map((d) => ({
      value: d.id.toString(),
      label: `${d.codigo} | ${d.name}`,
    }));

  const opcionesActividad = actividad.map((d) => ({
    value: d.id.toString(),
    label: `${d.codigo} | ${d.name}`,
  }));

  const opcionesTipoPersona = tipoPersona.map((d) => ({
    value: d.id.toString(),
    label: `${d.codigo} | ${d.name}`,
  }));

  const opcionesTipoDocReceptor = tipoDocReceptor.map((d) => ({
    value: d.id.toString(),
    label: `${d.codigo} | ${d.name}`,
  }));

  if (loading) return <Loader />;

  return (
    <div className="p-3 sm:p-6 max-w-7xl mx-auto">
      {/* Encabezado */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 sm:mb-6 gap-3">
        <div>
          <h2 className="text-xl sm:text-2xl font-bold text-slate-800">Directorio de Clientes</h2>
          <p className="text-xs sm:text-sm text-slate-500 mt-1">Administre los clientes receptores de la empresa</p>
        </div>
        <button
          onClick={openModalForNew}
          className="w-full sm:w-auto bg-indigo-600 text-white px-4 py-2.5 rounded-lg hover:bg-indigo-700 transition-colors shadow-sm shadow-indigo-200 font-medium flex items-center justify-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Agregar Cliente
        </button>
      </div>

      {/* Filtros */}
      <div className="flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-3 mb-4 sm:mb-6 bg-white p-3 sm:p-4 rounded-xl shadow-sm border border-slate-200">
        <div className="relative flex-grow">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg className="h-5 w-5 text-slate-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Buscar por nombre, NIT, NRC..."
            value={buscar}
            onChange={(e) => setBuscar(e.target.value)}
            className="pl-10 pr-4 py-2 w-full border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors bg-slate-50 focus:bg-white text-sm"
          />
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm text-slate-500 font-medium whitespace-nowrap">Mostrar:</span>
          <select
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setPage(1);
            }}
            className="border border-slate-300 rounded-lg px-3 py-2 bg-white focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
          >
            {[10, 15, 25, 50, 100, 250, 500, 1000].map((num) => (
              <option key={num} value={num}>
                {num} registros
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Vista Tabla — solo en pantallas medianas o mayores */}
      <div className="hidden md:block bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="overflow-x-auto custom-scrollbar">
          <table className="w-full text-sm text-left">
            <thead className="text-xs text-slate-500 bg-slate-50 uppercase border-b border-slate-200">
              <tr>
                <th className="px-4 py-3 font-semibold">Nombre</th>
                <th className="px-4 py-3 font-semibold">Tipo Cliente</th>
                <th className="px-4 py-3 font-semibold">Nombre Comercial</th>
                <th className="px-4 py-3 font-semibold">N° Registro</th>
                <th className="px-4 py-3 font-semibold">Tipo Doc. Receptor</th>
                <th className="px-4 py-3 font-semibold">Num. Doc.</th>
                <th className="px-4 py-3 font-semibold">Telefono</th>
                <th className="px-4 py-3 font-semibold">Actividad Económica</th>
                <th className="px-4 py-3 font-semibold">Departamento</th>
                <th className="px-4 py-3 font-semibold">Municipio</th>
                <th className="px-4 py-3 font-semibold text-center">Estado</th>
                <th className="px-4 py-3 font-semibold text-center sticky right-0 bg-slate-100 border-l border-slate-200 z-10 shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.05)]">Opciones</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {clienteReceptor.map((cclienteReceptor) => (
                <tr
                  key={cclienteReceptor.id}
                  className="hover:bg-indigo-50/50 transition-colors group"
                >
                  <td className="px-4 py-3 text-slate-700 font-medium whitespace-nowrap">{cclienteReceptor.nombre}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{cclienteReceptor.TipoPersona?.name}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{cclienteReceptor.nombreComercial}</td>
                  <td className="px-4 py-3 text-slate-600">{cclienteReceptor.nrc}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{cclienteReceptor.TipoDocumentoIdentificacionReceptor?.name}</td>
                  <td className="px-4 py-3 text-slate-600">{cclienteReceptor.numeroDocumento}</td>
                  <td className="px-4 py-3 text-slate-600">{cclienteReceptor.telefono}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{cclienteReceptor.CodigoActividadEconomica?.name}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{cclienteReceptor.Departamento?.name}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{cclienteReceptor.Municipio?.name}</td>
                  <td className="px-4 py-3 text-center">
                    <EstadoBadge status={cclienteReceptor.status} />
                  </td>
                  <td className="px-4 py-3 sticky right-0 bg-slate-100 group-hover:bg-slate-200 border-l border-slate-200 z-0 shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.03)] transition-colors">
                    <div className="flex items-center justify-center gap-2">
                      <button
                        type="button"
                        onClick={() => openModalForEdit(cclienteReceptor)}
                        className="bg-white border border-slate-200 text-slate-600 px-3 py-1.5 rounded-lg hover:bg-slate-50 hover:text-indigo-600 transition-colors text-xs font-medium"
                      >
                        Editar
                      </button>
                      {cclienteReceptor.status === 1 ? (
                        <button
                          type="button"
                          onClick={() => handleToggleStatus(cclienteReceptor)}
                          className="bg-red-50 text-red-600 border border-red-100 px-3 py-1.5 rounded-lg hover:bg-red-100 transition-colors text-xs font-medium"
                        >
                          Deshabilitar
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={() => handleToggleStatus(cclienteReceptor)}
                          className="bg-emerald-50 text-emerald-600 border border-emerald-100 px-3 py-1.5 rounded-lg hover:bg-emerald-100 transition-colors text-xs font-medium"
                        >
                          Activar
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Vista Cards — solo en móvil */}
      <div className="md:hidden space-y-3">
        {clienteReceptor.map((c) => (
          <div key={c.id} className="bg-white rounded-xl border border-slate-200 shadow-sm p-4">
            {/* Cabecera de la card */}
            <div className="flex items-start justify-between gap-2 mb-3">
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-slate-800 text-sm truncate">{c.nombre}</p>
                {c.nombreComercial && (
                  <p className="text-xs text-slate-500 truncate">{c.nombreComercial}</p>
                )}
              </div>
              <EstadoBadge status={c.status} />
            </div>

            {/* Datos en grid 2 columnas */}
            <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs mb-4">
              {c.TipoPersona?.name && (
                <div>
                  <span className="text-slate-400 font-medium uppercase tracking-wide">Tipo</span>
                  <p className="text-slate-700 font-medium">{c.TipoPersona.name}</p>
                </div>
              )}
              {c.nrc && (
                <div>
                  <span className="text-slate-400 font-medium uppercase tracking-wide">NRC</span>
                  <p className="text-slate-700 font-medium">{c.nrc}</p>
                </div>
              )}
              {c.TipoDocumentoIdentificacionReceptor?.name && (
                <div>
                  <span className="text-slate-400 font-medium uppercase tracking-wide">{c.TipoDocumentoIdentificacionReceptor.name}</span>
                  <p className="text-slate-700 font-medium">{c.numeroDocumento}</p>
                </div>
              )}
              {c.telefono && (
                <div>
                  <span className="text-slate-400 font-medium uppercase tracking-wide">Teléfono</span>
                  <p className="text-slate-700 font-medium">{c.telefono}</p>
                </div>
              )}
              {c.Departamento?.name && (
                <div>
                  <span className="text-slate-400 font-medium uppercase tracking-wide">Departamento</span>
                  <p className="text-slate-700 font-medium">{c.Departamento.name}</p>
                </div>
              )}
            </div>

            {/* Acciones */}
            <div className="flex gap-2 pt-3 border-t border-slate-100">
              <button
                type="button"
                onClick={() => openModalForEdit(c)}
                className="flex-1 bg-white border border-slate-200 text-slate-600 py-2 rounded-lg hover:bg-slate-50 hover:text-indigo-600 transition-colors text-xs font-medium text-center"
              >
                Editar
              </button>
              {c.status === 1 ? (
                <button
                  type="button"
                  onClick={() => handleToggleStatus(c)}
                  className="flex-1 bg-red-50 text-red-600 border border-red-100 py-2 rounded-lg hover:bg-red-100 transition-colors text-xs font-medium text-center"
                >
                  Deshabilitar
                </button>
              ) : (
                <button
                  type="button"
                  onClick={() => handleToggleStatus(c)}
                  className="flex-1 bg-emerald-50 text-emerald-600 border border-emerald-100 py-2 rounded-lg hover:bg-emerald-100 transition-colors text-xs font-medium text-center"
                >
                  Activar
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Paginación */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mt-4 sm:mt-6 px-1 gap-3">
        <p className="text-sm text-slate-500 text-center sm:text-left">
          Página <span className="font-medium">{page}</span> de <span className="font-medium">{totalPages}</span>
        </p>
        <div className="flex gap-1 bg-white p-1 rounded-lg border border-slate-200 justify-center overflow-x-auto">
          <button
            disabled={page === 1}
            onClick={() => fetchData(page - 1)}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${page === 1
              ? "text-slate-400 cursor-not-allowed"
              : "text-slate-600 hover:bg-slate-100"
              }`}
          >
            ← Ant
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => {
            if (totalPages > 7) {
              if (num === 1 || num === totalPages || (num >= page - 1 && num <= page + 1)) {
                return (
                  <button
                    key={num}
                    onClick={() => fetchData(num)}
                    className={`min-w-[32px] px-2 py-1.5 rounded-md text-sm font-medium transition-colors ${page === num
                      ? "bg-indigo-50 text-indigo-600"
                      : "text-slate-600 hover:bg-slate-100"
                      }`}
                  >
                    {num}
                  </button>
                );
              } else if (num === page - 2 || num === page + 2) {
                return <span key={num} className="px-2 py-1.5 text-slate-400">...</span>;
              }
              return null;
            }

            return (
              <button
                key={num}
                onClick={() => fetchData(num)}
                className={`min-w-[32px] px-2 py-1.5 rounded-md text-sm font-medium transition-colors ${page === num
                  ? "bg-indigo-50 text-indigo-600"
                  : "text-slate-600 hover:bg-slate-100"
                  }`}
              >
                {num}
              </button>
            );
          })}

          <button
            disabled={page === totalPages}
            onClick={() => fetchData(page + 1)}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${page === totalPages
              ? "text-slate-400 cursor-not-allowed"
              : "text-slate-600 hover:bg-slate-100"
              }`}
          >
            Sig →
          </button>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex justify-center items-start sm:items-center z-50 p-2 sm:p-6 overflow-y-auto">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-4xl flex flex-col my-4 sm:my-8 animate-fade-in-up">
            <div className="flex items-center justify-between p-4 sm:p-6 border-b border-slate-100">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-indigo-50 flex items-center justify-center text-indigo-600 shrink-0">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <h3 className="text-base sm:text-xl font-bold text-slate-800">
                  {editMode ? "Actualizar Cliente" : "Registrar Cliente"}
                </h3>
              </div>
              <button onClick={() => setShowModal(false)} className="text-slate-400 hover:text-slate-600 transition-colors p-1">
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-4 sm:p-6 overflow-y-auto custom-scrollbar max-h-[65vh] sm:max-h-[65vh]">
              <form onSubmit={handleSubmit} id="cliente-form" className="space-y-4 sm:space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Tipo de Persona</label>
                    <ReactSelect
                      options={opcionesTipoPersona}
                      value={opcionesTipoPersona.find((opt) => opt.value === form.tipoPersona) || null}
                      onChange={(val) => handleSelectChange(val, "tipoPersona")}
                      placeholder="Seleccione tipo persona..."
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isSearchable
                      isClearable
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Nombre o Razón Social</label>
                    <input
                      type="text"
                      name="nombre"
                      value={form.nombre}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Nombre Comercial</label>
                    <input
                      type="text"
                      name="nombreComercial"
                      value={form.nombreComercial}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required={form.tipoPersona !== "1"}
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">NRC (N° Registro)</label>
                    <input
                      type="text"
                      name="nrc"
                      value={form.nrc}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required={form.tipoPersona !== "1"}
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Tipo Doc. Identificador <span className="text-red-500">*</span></label>
                    <ReactSelect
                      options={opcionesTipoDocReceptor}
                      value={opcionesTipoDocReceptor.find((opt) => opt.value === form.id_documento_identificacion_receptor) || null}
                      onChange={(val) => handleSelectChange(val, "id_documento_identificacion_receptor")}
                      placeholder="Seleccione doc..."
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isSearchable
                      isClearable
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">N° Doc. Identificador <span className="text-red-500">*</span></label>
                    <input
                      type="text"
                      name="numeroDocumento"
                      value={form.numeroDocumento}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Teléfono</label>
                    <input
                      type="text"
                      name="telefono"
                      value={form.telefono}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Correo Electrónico</label>
                    <input
                      type="email"
                      name="correo"
                      value={form.correo}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Departamento</label>
                    <ReactSelect
                      options={opcionesDepartamento}
                      value={opcionesDepartamento.find((opt) => opt.value === form.departamento) || null}
                      onChange={(val) => handleSelectChange(val, "departamento")}
                      placeholder="Seleccione departamento..."
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isSearchable
                      isClearable
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Municipio</label>
                    <ReactSelect
                      options={opcionesMunicipio}
                      value={opcionesMunicipio.find((opt) => opt.value === form.municipio) || null}
                      onChange={(val) => handleSelectChange(val, "municipio")}
                      placeholder="Seleccione municipio..."
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isSearchable
                      isClearable
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Actividad Económica</label>
                    <ReactSelect
                      options={opcionesActividad}
                      value={opcionesActividad.find((opt) => opt.value === form.actividad) || null}
                      onChange={(val) => handleSelectChange(val, "actividad")}
                      placeholder="Seleccione actividad..."
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isSearchable
                      isClearable
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Estado del Cliente</label>
                    <select
                      name="status"
                      value={form.status}
                      onChange={handleChange}
                      className={`w-full border border-slate-300 rounded-lg px-4 py-2.5 font-medium transition-colors focus:ring-2 focus:ring-indigo-500 outline-none text-sm ${form.status === "1"
                        ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                        : form.status === "0"
                          ? "bg-rose-50 text-rose-700 border-rose-200"
                          : "bg-white text-slate-700"
                        }`}
                      required
                    >
                      <option value="" disabled>Seleccione un estado...</option>
                      <option value="1">Activo</option>
                      <option value="0">Inactivo</option>
                    </select>
                  </div>

                  <div className="col-span-1 sm:col-span-2 lg:col-span-3">
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Dirección Completa</label>
                    <textarea
                      name="direccionComplemento"
                      value={form.direccionComplemento}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors min-h-[80px] resize-y custom-scrollbar text-sm"
                      required
                    ></textarea>
                  </div>
                </div>
              </form>
            </div>

            <div className="p-4 sm:p-6 border-t border-slate-100 bg-slate-50 flex flex-col-reverse sm:flex-row sm:items-center sm:justify-end gap-2 sm:gap-3 rounded-b-2xl">
              <button
                type="button"
                onClick={() => setShowModal(false)}
                className="w-full sm:w-auto px-5 py-2.5 rounded-lg border border-slate-300 text-slate-700 font-medium hover:bg-white focus:ring-2 focus:ring-slate-200 transition-colors text-sm"
                disabled={submitting}
              >
                Cancelar
              </button>

              <button
                type="submit"
                form="cliente-form"
                disabled={submitting}
                className={`w-full sm:w-auto px-6 py-2.5 rounded-lg flex items-center justify-center gap-2 font-medium shadow-sm transition-all text-sm ${submitting
                  ? "bg-indigo-400 cursor-not-allowed shadow-none"
                  : "bg-indigo-600 hover:bg-indigo-700 hover:shadow-indigo-200"
                  } text-white`}
              >
                {submitting && (
                  <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
                {submitting
                  ? editMode
                    ? "Actualizando datos..."
                    : "Guardando cliente..."
                  : editMode
                    ? "Actualizar Cliente"
                    : "Guardar Cliente"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Clientes;
